import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';


const filter = {
	InvoiceDateFrom: null as Date | null,
	InvoiceDateTo: null as Date | null,
	WorkshopIds: [] as number[],
	BrandIds: [] as string[],
	LocalSuppliersIds: [] as number[],	
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		WorkshopId: [],
		Brands: [],
		LocalSuppliers: []
	},
	filter,
	tableSetting: {
		isEditable: true,
		columnSettings: {
			VALUE: { isEditable: true, required: true },
		},
	},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
